import {Article} from "./article";
import {PricingItem} from "./pricing-item";

export class DeviceConsumablePricingItem extends PricingItem {

    constructor(public readonly device?: Article,
                public readonly consumable?: Article,
                public readonly consumableExtraPrice?: string,
                public readonly oldConsumableExtraPrice?: string,
                public readonly specificities?: Record<string, any>,
                public readonly effTheo? : number,
                public readonly franchise? : any,
                public readonly discount?: string,
                public readonly totalAppliedPriceColor?: string
) {
        super();
    }
}
